import React, { useState } from 'react';
import styles from './Alert.module.css'
import { useSelector } from 'react-redux';
import { TriangleAlertIcon } from '../icons/Icons';
import { getAlertColorsAndIcon, formatAlertDescription } from '../../utils/alertUtils';
import { formatTimeAndFullMonth } from '../../utils/dateUtils';
import CustomDropdownToggle from '../CustomDropdownToggle';
import { Dropdown } from 'react-bootstrap';
import EllipsesIcon from '../icons/EllipsesIcon';

const AlarmHistoryItem = (props) => {

    const {
        alert,
        dateFormat
    } = props;

    const careTeam = useSelector((state) => state.patient.careTeam);
    const userUnitPreference = useSelector((state) => state.userInfo.unitType);
    const getResolverName = () => {
        let careTeamMember = careTeam.find((staff)=> staff.id === alert.alert_resolverId);
        if (careTeamMember) {
            return `${careTeamMember.firstName} ${careTeamMember.lastName}`
        }
        return "Unknown"
    };
    const resolverName = getResolverName();

    let {icon, background} = getAlertColorsAndIcon(alert);
    const createdDate = alert.alert_lastUpdatedTimestamp || alert.createdDate;
    return (
        <div className={styles.historyItem}>
            <div className={styles.historyTopSection} style={{ background: background }}>
                <div className={styles.historyTitle}>

                    {icon}
                    {alert.alert_display_name ?? alert.alert_name}
                    <div style={{flex:1}}></div>
                    <Dropdown>
                        <Dropdown.Toggle as={CustomDropdownToggle} id="custom-alert-history-dropdown">
                            <EllipsesIcon />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="custom-bootstrap-menu">

                            <Dropdown.Item>View Alarm History</Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className={styles.historyDates}>
                    <span>Created Date: </span>
                    {formatTimeAndFullMonth(createdDate, dateFormat)}
                    <span style={{borderLeft:"1px solid lightgrey", paddingLeft:"5px"}}>
                        {alert.alert_resolverId === "system" ? 
                            <span>Resolved by system at {alert.alert_resolvedTimestamp ? formatTimeAndFullMonth(alert.alert_resolvedTimestamp, dateFormat) : "Unknown"}</span>
                            :
                            `Resolved Date: ${alert.alert_resolvedTimestamp ? formatTimeAndFullMonth(alert.alert_resolvedTimestamp, dateFormat) : "Unknown"} by ${resolverName}`
                        }
                    </span>
                </div>
            </div>

            <div className={styles.historyDescription}>
                {formatAlertDescription(alert, userUnitPreference)}
            </div>

        </div>
    );
};

export default AlarmHistoryItem;
